<template>
  <div>
	<el-select @change="change" style="width: 100%"  size="small" v-model="value"  placeholder="请选择" >
		<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
		</el-option>
	</el-select>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    modelValue: {
      type: [String, Number], // 根据你传递的类型，修改这里的类型
      default: "",
    },
	vals:{
		type:Number,
		default:""
	}
  },
  data() {
    return {
      value: "",
      options: [],
    };
  },
  created() {
    // 获取商品分类列表
    this.getCategoryList();
  },
  methods: {
    change() {
      this.$emit("getValue", this.value);
    },
    getCategoryList() {
      let _this = this;
      _this.axios.get("/api/weishop/admin/plugin/staff/product/index",{
		  params:{
			  page:1,
			  limit:10000
		  }
	  }).then((res) => {
        if (res.code == 200) {
          _this.options = res.data.data
        } else {
          eltips(res.msg, "error");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped></style>
